import {h, Fragment} from "preact"
import { formatCurrency } from '../helpers'

export default ({ product }) => {
  const getCustomFieldValue = (customFields, key) => {
    const field = customFields.find((field) => field.key === key)
    return field ? field.value : null
  }

  return (
    <product-quick-swatch product-id={product.id}>
      <script
        type="application/json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            productUrl: product.url,
            title: product.name ?? product.title ?? '',
            productTags: product.tags1 ?? [],
            optionsWithValues: [
              {
                name: 'Color',
                values: [...new Set(product.skus
                  .map(s => getCustomFieldValue(s.customFields, 'color'))
                  .filter(Boolean))]
              },
              {
                name: 'Size',
                values: [...new Set(product.skus
                  .map(s => getCustomFieldValue(s.customFields, 'size'))
                  .filter(Boolean))]
              }
            ].filter(opt => opt.values.length),

            // Map Nosto SKUs to the variant shape our element expects
            variants: product.skus.map(sku => {
              const color = getCustomFieldValue(sku.customFields, 'color');
              const size = getCustomFieldValue(sku.customFields, 'size');
              const swymDisabled = String(getCustomFieldValue(sku.customFields, 'custom-swym_disabled')) === 'true';
              const swymComing = String(getCustomFieldValue(sku.customFields, 'custom-swym_coming_soon')) === 'true';

              return {
                id: sku.id,
                title: color || size || sku.name,

                available: sku.availability !== 'OutOfStock',
                price: formatCurrency(Number(sku.price)),
                compare_at_price: sku.listPrice ? formatCurrency(Number(sku.listPrice)) : null,

                image: sku.imageUrl,

                metafields: {
                  custom: {
                    swym_disabled: { value: swymDisabled },
                    swym_coming_soon: { value: swymComing }
                  }
                }
              };
            })
          })
        }}
      />
    </product-quick-swatch>
  )
}
